/**
 * Logo pequeno + nome da empresa numa celula de tabela.
 *
 * Decisao nao obvia: a identidade visual vem de `useCompany().companies` (a
 * mesma fonte do cabecalho), cruzada pelo `companyId` da linha. Se a linha
 * vier de uma empresa fora dessa lista, cai nas iniciais do nome que a
 * propria linha trouxe -- a conversao nunca some do extrato por falta de logo.
 */

import { CompanyLogo } from '../../../components/ui';
import type { CompanySummary } from '../../../types';

export type IdentidadeVisual = Pick<CompanySummary, 'id' | 'name' | 'logoInitials' | 'logoTone' | 'logoUrl'>;

function iniciais(nome: string): string {
  const partes = nome.trim().split(/\s+/).filter((p) => p.length > 0);
  const primeira = partes[0]?.charAt(0) ?? 'E';
  const segunda = partes.length > 1 ? (partes[partes.length - 1]?.charAt(0) ?? '') : (partes[0]?.charAt(1) ?? '');
  return `${primeira}${segunda}`.toUpperCase();
}

export function identidadeDaEmpresa(companyId: string, companies: readonly CompanySummary[], nomeFallback: string): IdentidadeVisual {
  const achada = companies.find((c) => c.id === companyId);
  if (achada !== undefined) {
    return achada;
  }
  return { id: companyId, name: nomeFallback, logoInitials: iniciais(nomeFallback), logoTone: 1, logoUrl: null };
}

export function IdentidadeEmpresa({ empresa, size = 'sm' }: { readonly empresa: IdentidadeVisual; readonly size?: 'sm' | 'md' }): JSX.Element {
  return (
    <span className="flex min-w-0 items-center gap-2">
      <CompanyLogo company={empresa} size={size} />
      <span className="truncate font-medium text-ink">{empresa.name}</span>
    </span>
  );
}
